import React, { Component } from 'react'
import { connect } from 'react-redux'
import { configuration } from '../../configuration'

import './styles.css'

class Footer extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    const footer = this.props.footer ? this.props.footer : configuration().footerMessage
    // Required: Used in template string into configuration
    const year = new Date().getFullYear()
    const footerMessage = eval('`' + footer + '`')
    return (
      <div className="footer">
        <p>
          {'Powered by  '}

          <img className="footer-logo" src={"../images/logo-caribou.png"} alt="Caribou logo" />

          {'  © Todos los derechos reservados'}
        </p>
        <div className="footer-message">
          <p>{footerMessage}</p>
        </div>
      </div>
    )
  }

}

const mapStateToProps = state => {
  return {
    footer: state.checkout.workshop.footer
  }
}

const bindActions = dispatch => ({

});

export default connect(mapStateToProps, bindActions)(Footer)



// WEBPACK FOOTER //
// ./src/components/footer/index.js